export class Lesson {
    title: string;
    background: string;
    description: string;
    sections: string[];
}